__turbopack_context__.v({
  "app_light_theme": "promotion-products-modal-module-scss-module__Zans0G__app_light_theme",
  "buttons": "promotion-products-modal-module-scss-module__Zans0G__buttons",
  "buttons__nextButton": "promotion-products-modal-module-scss-module__Zans0G__buttons__nextButton",
  "buttons__prevButton": "promotion-products-modal-module-scss-module__Zans0G__buttons__prevButton",
  "content": "promotion-products-modal-module-scss-module__Zans0G__content",
  "description": "promotion-products-modal-module-scss-module__Zans0G__description",
  "descriptionWithTabs": "promotion-products-modal-module-scss-module__Zans0G__descriptionWithTabs",
  "heading": "promotion-products-modal-module-scss-module__Zans0G__heading",
  "modal": "promotion-products-modal-module-scss-module__Zans0G__modal",
  "pagination": "promotion-products-modal-module-scss-module__Zans0G__pagination",
  "paginationActive": "promotion-products-modal-module-scss-module__Zans0G__paginationActive",
  "promotion": "promotion-products-modal-module-scss-module__Zans0G__promotion",
  "slide": "promotion-products-modal-module-scss-module__Zans0G__slide",
  "slider": "promotion-products-modal-module-scss-module__Zans0G__slider",
  "swiper": "promotion-products-modal-module-scss-module__Zans0G__swiper",
  "tabButton": "promotion-products-modal-module-scss-module__Zans0G__tabButton",
  "tabButtonActive": "promotion-products-modal-module-scss-module__Zans0G__tabButtonActive",
  "tabs": "promotion-products-modal-module-scss-module__Zans0G__tabs",
  "viewport": "promotion-products-modal-module-scss-module__Zans0G__viewport",
});
